export default __webpack_public_path__ + "static/media/expose4.a5b82376.png";